export default __webpack_public_path__ + "static/brian-vaughn-07c580f7c345589685ea12c16b247232.jpg";